import React, {useCallback, useEffect, useState, useRef} from "react";
import axios from "axios";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import PdfPng from '../../Assets/Pdf.png';
import { Button } from "react-bootstrap";
import { OAuthApiStartPolling, OAuthApiStopPolling } from "../../ExternalApi/OAuthApi"
import { ConfigurationApiForward } from "../../ExternalApi/ConfigurationApi"
import IntegrationWizardDots from "../IntegrationWizard/IntegrationWizardDots"
import { IsEmptyString } from "../GeneralFunctions"

const DatasourceMyob = (props) => {
    
    const [mRepainter, SetRepainter] = useState(false); 
    const [mWaitingForState, SetWaitingForState] = useState("")
    const [mError, SetError] = useState("") 
    const [mOAuthWindow, SetOAuthWindow] = useState(null) 

    const cClientId = "c80b4fb9-901f-48e2-9ba5-0544e67c3092"
    const cClientSecret = "q6PuFkvc35QW7zDbeaSl3B9T"
    const cRedirectUrl = "https://auth.cloudcti.nl/webapi/oauth2"


    useEffect(() => {
        if ((props.IntegrationSettings.DatasourceSettings["Country"] === "")
            || (props.IntegrationSettings.DatasourceSettings["Country"] === null)
            || (props.IntegrationSettings.DatasourceSettings["Country"] === undefined))
        {
            props.IntegrationSettings.DatasourceSettings["Country"] = "au"
        }

        SetReady()
        SetRepainter(!mRepainter)
      }, []); 

    const UpdateDatasourceSetting = (aNewValue, aIdentifier) =>
    {
        props.IntegrationSettings.DatasourceSettings[aIdentifier] = aNewValue
        SetRepainter(!mRepainter)

        SetReady()
    }

    const SetReady = () => 
    {
        props.OnSetReady(props.IntegrationSettings.DatasourceSettings.BusinessId && props.IntegrationSettings.DatasourceSettings.RefreshToken)
    }

    const GetParamFromUrl = (aUrl, ParamName) => 
    {
        try 
        {
            console.log("GetParamFromUrl1", aUrl)
            const Url = new URL(aUrl)
            console.log("GetParamFromUrl2", Url.search)
            const UrlParams = new URLSearchParams(Url.search)
            console.log("GetParamFromUrl3", UrlParams)
            return UrlParams.get(ParamName)
        }
        catch (error)
        {
            console.log("GetParamFromUrlE", error)
            return null
        }
    }

    async function GetTokens(aAuthorizationCode, aBusinessId) 
    {
        let Result = await ConfigurationApiForward(
            props.SecurityToken, 
            "https://secure.myob.com/oauth2/v1/authorize", 
            "POST", 
            "client_id=" + cClientId + "&client_secret=" + cClientSecret + "&redirect_uri=https%3A%2F%2Fauth.cloudcti.nl%2Fwebapi%2Foauth2&grant_type=authorization_code&code=" + aAuthorizationCode, 
            "application/json", 
            "application/x-www-form-urlencoded")
        if (Result != null)
        {
            UpdateDatasourceSetting(Result.data.access_token, "AccessToken")
            UpdateDatasourceSetting(Result.data.refresh_token, "RefreshToken")
            UpdateDatasourceSetting(aBusinessId, "BusinessId")
        }
        else
        {
            SetError("Failed to retrieve tokens")
        }

        SetWaitingForState("")
    }

    const OAuthPollResult = (aResult, aValue, aOAuthWindow) =>
    {
        try 
        { 
            if (aOAuthWindow !== null)
            {
                aOAuthWindow.close() 
                aOAuthWindow = null
                SetOAuthWindow(null)
            }
        } 
        catch {}

        if (aResult)
        {
            console.log("OAuthPollResult success",aValue)
            if (aValue.Code && aValue.ResponseUrl)
            {
                const BusinessId = GetParamFromUrl(aValue.ResponseUrl.replaceAll("&amp;","&"),"businessId")
                if (!IsEmptyString(BusinessId))
                {
                    GetTokens(aValue.Code, BusinessId)
                }
                else
                {
                    SetError("OAUTH response returned no BusinessId") 
                }                
            }
            else
            {
                SetError("Failed to authenticate. No authorizationcode found")  
            }
        }
        else
        {
            console.log("OAuthPollResult error",aValue)  
            SetError("Failed to authenticate")          
        }
    }

    const RandomState = () => 
    {
        let Result = "client2020WEB"

        var characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
        for ( var i = 0; i < 27; i++ ) 
        {
            Result += characters.charAt(Math.floor(Math.random() * characters.length))
        }
        
        return Result
    }

    const StartOAuth = () =>
    {
        const State = RandomState()

        const OAuthUrl = "https://secure.myob.com/oauth2/account/authorize" +
            "?client_id=" + cClientId +
            "&redirect_uri=https%3A%2F%2Fauth.cloudcti.nl%2Fwebapi%2Foauth2" +
            '&scope=sme-company-file+sme-contacts-customer+sme-contacts-supplier+sme-contacts-personal+sme-contacts-employee' +
            "&response_type=code" +
            "&prompt=consent" +
            "&state=" + State
        const OAuthWindow = window.open(OAuthUrl, "_blank", 'popup=yes,titlebar=0,left=' + ((screen.availWidth - 750)/2)  + ',top=' + ((screen.availHeight - 750)/2)  + ',width=750,height=750')
        SetOAuthWindow(OAuthWindow)
        OAuthApiStartPolling(State, OAuthPollResult, OAuthWindow)

        SetWaitingForState(State)
    }

    const StopOAuth = () =>
    {
        OAuthApiStopPolling()
        try 
        { 
            if (mOAuthWindow !== null)
            {
                mOAuthWindow.close() 
                SetOAuthWindow(null)
            }
        } 
        catch {}        

        SetWaitingForState("")
    }

    const BrandingId = sessionStorage.getItem("BrandingId")

    const OAuthBody = props.IntegrationSettings.DatasourceSettings.RefreshToken ?
        //Authorization OK
        <div className="scriptitembody">
            {Translate("$Application connection token received succesfully").replace("$Application","MYOB")}
        </div> :
        (mError ?
            //Authorization failed. Show error and connect button
            <div className="scriptitembody">
                <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StartOAuth()} type="submit">{Translate("Connect")}</Button><br/>
                <div>{mError}</div>
            </div> :
            (mWaitingForState ?
                //Waiting for authorization. Show dot counter and cancel button
                <div className="scriptitembody">
                    <Button variant="danger" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StopOAuth()} type="submit">{Translate("Cancel")}</Button><br/><br/>
                    <div>{Translate("Waiting for OAUTH verification")}<IntegrationWizardDots/></div>
                </div> :
                <div className="scriptitembody">
                    <Button variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} onClick={() => StartOAuth()} type="submit">{Translate("Connect")}</Button>
                </div> 
            )
        )

    return (
        <span>
            <div className="wizardfieldname">{Translate("Region").toUpperCase()} <span className="redtext">*</span></div>
            <div className="wizardfieldvalue">
                <select name="Region" value={props.IntegrationSettings.DatasourceSettings["Country"] || "au"} onChange={evt => UpdateDatasourceSetting(evt.target.value, "Country")} className="wizardinputfield">
                    <option value="au">Australia</option>
                    <option value="nz">New Zealand</option>
                </select>
            </div>
            {OAuthBody}
        </span>
    )
}

DatasourceMyob.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceMyob